export const PERSONAL_CONVERSATION_SCOPE = "personal" as const;
export const ALL_PROJECTS_CONVERSATION_SCOPE = "all" as const;

export type ConversationScope = {
  principalId: string;
  organizationId: string;
  projectId: string;
};

export type ConversationRequestScope = {
  organizationId: string | null;
  projectId: string | null;
};

const scopeParts = (scope: ConversationScope) => [
  scope.principalId,
  scope.organizationId || PERSONAL_CONVERSATION_SCOPE,
  scope.projectId || ALL_PROJECTS_CONVERSATION_SCOPE,
] as const;

export const conversationScopeIdentity = (scope: ConversationScope) =>
  JSON.stringify(scopeParts(scope));

export const getConversationRequestScope = (
  scope: ConversationScope,
): ConversationRequestScope => ({
  organizationId:
    scope.organizationId === PERSONAL_CONVERSATION_SCOPE
      ? null
      : scope.organizationId,
  projectId:
    scope.projectId === ALL_PROJECTS_CONVERSATION_SCOPE
      ? null
      : scope.projectId,
});

export const conversationQueryKeys = {
  lists: (scope: ConversationScope) =>
    ["conversations", "scope", ...scopeParts(scope)] as const,
  history: (scope: ConversationScope, search: string) =>
    [...conversationQueryKeys.lists(scope), "history", search] as const,
  sidebar: (scope: ConversationScope) =>
    [...conversationQueryKeys.lists(scope), "sidebar"] as const,
  details: (scope: ConversationScope) =>
    ["conversation", "scope", ...scopeParts(scope)] as const,
  detailConversation: (
    scope: ConversationScope,
    conversationId: string,
  ) =>
    [
      ...conversationQueryKeys.details(scope),
      "detail",
      conversationId,
    ] as const,
  detail: (
    scope: ConversationScope,
    conversationId: string,
    routeNamespace: string,
  ) =>
    [
      ...conversationQueryKeys.detailConversation(scope, conversationId),
      routeNamespace,
    ] as const,
  documents: (scope: ConversationScope, conversationId: string) =>
    ["documents", "scope", ...scopeParts(scope), conversationId] as const,
};
